import { Component } from '@angular/core';
import { LogoutButtonComponent } from '../logout-button/logout-button.component';
import { PromoteToAdminFormComponent } from "./promote-to-admin-form/promote-to-admin-form.component";

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [LogoutButtonComponent, PromoteToAdminFormComponent],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss'
})
export class AdminComponent {

}
